// extracted by mini-css-extract-plugin
export default {"menuItem":"TabSliderMenu_menuItem__G3DMD","menuItemActive":"TabSliderMenu_menuItemActive__68nAC"};